import { ChipDownContainer, EllipsisDropdownItem } from "@similarweb/ui-components";
import { useMemo } from "react";
import type { ICategoryLeadersServices } from "app/pages/industry-analysis/category-leaders/CategoryLeaders.types";
import { PaidOrganicFilterEnum } from "./PaidOrganicFilter.types";

interface IPaidOrganicFilterProps {
    onSelectId: (id: PaidOrganicFilterEnum) => void;
    selectedId: PaidOrganicFilterEnum;
    services: ICategoryLeadersServices;
}

export const PaidOrganicFilter = (props: IPaidOrganicFilterProps) => {
    const { onSelectId, selectedId, services } = props;

    const filterItems = useMemo(() => {
        return [
            {
                text: services.translate("category.leaders.search.table.filter.organic"),
                id: PaidOrganicFilterEnum.Organic,
            },
            {
                text: services.translate("category.leaders.search.table.filter.paid"),
                id: PaidOrganicFilterEnum.Paid,
            },
        ];
    }, [services]);

    const selectedItemText = useMemo(() => {
        const hasSelectedId = selectedId !== null && typeof selectedId !== "undefined";
        return hasSelectedId ? filterItems[selectedId]?.text : null;
    }, [selectedId, filterItems]);

    return (
        <ChipDownContainer
            data-automation="category-leaders-paid-organic-filter"
            width={220}
            onClick={(value) => onSelectId(value.id)}
            tooltipDisabled={true}
            selectedText={selectedItemText}
            onCloseItem={() => onSelectId(null)}
            buttonText={services.translate("category.leaders.search.table.filter.organicpaid")}
            noResultsMessage={services.translate("dropdown.no.results")}
        >
            {filterItems.map((item, index) => {
                return (
                    <EllipsisDropdownItem
                        selected={selectedId === item.id}
                        // @ts-expect-error Type number is not assignable to type string
                        id={item.id}
                        key={index}
                    >
                        {item.text}
                    </EllipsisDropdownItem>
                );
            })}
        </ChipDownContainer>
    );
};
